import AutocompleteInput from './AutocompleteInput';
import type { FormatPattern } from './AutocompleteInput';

export type { FormatPattern };
export default AutocompleteInput;
